import React from 'react';
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';
import Footer from '../Footer';
import Info from '../info';
function Home() {
  return (
    <>
      <HeroSection />
      <Info />
      <Footer />
    </>
  );
}

export default Home;
